
/**
 * A `PropertyBinding` represents a mapping between a property name
 * and an attribute name. It is parsed from a string of the form
 * `"prop: attr"`; or simply `"propAndAttr" where the property
 * and attribute have the same identifier.
 */
export class PropertyBinding {
  bracketAttr: string;
  bracketParenAttr: string;
  parenAttr: string;
  onAttr: string;
  bindAttr: string;
  bindonAttr: string;
/**
 * @param {?} prop
 * @param {?} attr
 */
constructor(public prop: string,
public attr: string) { this.parseBinding(); }
/**
 * @return {?}
 */
private parseBinding() {
    this.bracketAttr = `[${this.attr}]`;
    this.parenAttr = `(${this.attr})`;
    this.bracketParenAttr = `[(${this.attr})]`;
    const /** @type {?} */ capitalAttr = this.attr.charAt(0).toUpperCase() + this.attr.substr(1);
    this.onAttr = `on${capitalAttr}`;
    this.bindAttr = `bind${capitalAttr}`;
    this.bindonAttr = `bindon${capitalAttr}`;
  }
}

function PropertyBinding_tsickle_Closure_declarations() {
/** @type {?} */
PropertyBinding.prototype.bracketAttr;
/** @type {?} */
PropertyBinding.prototype.bracketParenAttr;
/** @type {?} */
PropertyBinding.prototype.parenAttr;
/** @type {?} */
PropertyBinding.prototype.onAttr;
/** @type {?} */
PropertyBinding.prototype.bindAttr;
/** @type {?} */
PropertyBinding.prototype.bindonAttr;
/** @type {?} */
PropertyBinding.prototype.prop;
/** @type {?} */
PropertyBinding.prototype.attr;
}

